import { Maximize2 } from 'lucide-react';

function ProductCard({ img, alt, title, onViewClick }) {
  return (
    <div 
      onClick={onViewClick}
      className="group relative bg-white rounded-2xl overflow-hidden shadow-md h-96 cursor-pointer border border-gray-200/80 transition-all duration-300 hover:shadow-xl"
    >
      {/* Raw Structural Asset Viewport */}
      <img
        src={img}
        alt={alt}
        className="w-full h-full object-cover transition-transform duration-700 ease-out group-hover:scale-105"
        loading="lazy"
      />

      {/* Complex Dark Gradient Masking targeting theme palette values */}
      <div className="absolute inset-0 bg-gradient-to-t from-cogBrand via-cogBrand/50 to-transparent opacity-0 group-hover:opacity-100 transition-opacity duration-500" />

      {/* Floating Meta Container */}
      <div className="absolute inset-0 flex flex-col justify-end p-6 translate-y-6 group-hover:translate-y-0 opacity-0 group-hover:opacity-100 transition-all duration-500 ease-out z-10">
        
        <h4 className="font-display font-bold text-lg sm:text-xl text-white mb-4 leading-snug tracking-wide">
          {title}
        </h4>
        
        <div className="inline-flex items-center gap-2 text-cogCyan font-bold text-xs uppercase tracking-widest self-start transition-colors duration-300 hover:text-white">
          <Maximize2 className="w-4 h-4 text-cogCyan" />
          <span>Full Screen</span>
        </div>
      </div>
    </div>
  );
}

export default ProductCard;